import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { PageHead } from "@/components/storefront/common";
import { User, MapPin, Package, Star, LogOut } from "lucide-react";

const LINKS = [
  { to: "/account/profile", label: "Profile", icon: User },
  { to: "/account/addresses", label: "Addresses", icon: MapPin },
  { to: "/account/orders", label: "Orders", icon: Package },
  { to: "/account/reviews", label: "My Reviews", icon: Star },
];

export default function Account() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="container-x py-8">
      <PageHead title={`Hi, ${user?.name?.split(" ")[0] || "there"}`} crumbs={[{ label: "Home", to: "/" }, { label: "Account" }]} />
      <div className="grid grid-cols-1 lg:grid-cols-[240px_1fr] gap-8">
        <aside className="h-fit min-w-0 w-full">
          <nav className="rounded-xl border border-slate-200 bg-white p-2 flex lg:flex-col gap-1 overflow-x-auto no-scrollbar max-w-full">
            {LINKS.map((l) => (
              <NavLink key={l.to} to={l.to} data-testid={`account-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className={({ isActive }) => `flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm font-medium whitespace-nowrap transition ${isActive ? "bg-slate-900 text-white" : "text-slate-600 hover:bg-slate-50"}`}>
                <l.icon className="h-4 w-4" /> {l.label}
              </NavLink>
            ))}
            <button onClick={() => { logout(); navigate("/"); }} data-testid="account-logout"
              className="flex items-center gap-2.5 px-3 py-2.5 rounded-lg text-sm font-medium text-red-600 hover:bg-red-50 transition whitespace-nowrap">
              <LogOut className="h-4 w-4" /> Logout
            </button>
          </nav>
        </aside>
        <div className="min-w-0"><Outlet /></div>
      </div>
    </div>
  );
}
